<template>
  <div>
    <table-layout
      pkField="source_id"
      :selected.sync="selected"
      :isAdmin="isAdmin"
      :loading="serversLoading"
      :items="sources"
      :columns="columns"
      :addOptions="sourcesTypes"
      @click:addNew="addSource"
    >
      <template #actions>
        <b-dropdown-item @click="testSources" aria-role="listitem">{{ $t('lists.test') }}</b-dropdown-item>
        <b-dropdown-item @click="openDialogRemove" aria-role="listitem">{{ $t('lists.deleteDetail') }}</b-dropdown-item>
      </template>
    </table-layout>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import TableLayout from '@/layout/TableLayout'

const { mapState: mapUserState } = createNamespacedHelpers('general')

export default {
  name: 'Sources',
  components: {
    TableLayout
  },
  created() {
    this.refetch()
    this.getTypes()
  },
  computed: {
    ...mapUserState({
      role: state => state.user.role
    }),
    isAdmin() {
      return this.role === 'ADMIN'
    }
  },
  data() {
    return {
      sources: [],
      serversLoading: false,
      sourcesTypes: [],
      columns: [
        {
          sortable: true,
          field: 'name',
          label: 'columns.name',
          route: {
            name: 'source',
            params: [
              {
                name: 'source_id',
                field: 'source_id'
              }
            ]
          }
        },
        {
          sortable: true,
          field: 'type',
          label: 'columns.source.type'
        },
        {
          sortable: true,
          field: 'origin_time',
          label: 'columns.origin_time'
        },
        {
          sortable: true,
          field: 'description',
          label: 'columns.description',
          bindHtml: true
        },
        {
          loadable: true,
          sortable: true,
          field: 'progress',
          label: 'columns.progress'
        },
        {
          sortable: true,
          field: 'created_time',
          label: 'columns.created_time'
        }
      ],
      selected: []
    }
  },
  methods: {
    ...mapActions('general', ['setServerName']),
    addSource(type) {
      this.$router.push({
        name: 'add_source',
        query: { type: type },
        params: {
          server_id: this.$route.params.server_id
        }
      })
    },
    refetch() {
      if (!this.serversLoading) {
        const body = {
          server_id: this.$route.params.server_id
        }
        const searchParams = new URLSearchParams(body)
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/sources?${searchParams}`
        this.serversLoading = true
        fetch(url, {
          method: 'GET',
          credentials: 'include'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            this.sources = data.sources
            this.setServerName(data.server_name)
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.serversLoading = false
          })
      }
    },
    getTypes() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/sources/types?server_id=${
        this.$route.params.server_id
      }`
      fetch(url, {
        method: 'GET',
        credentials: 'include'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(data => {
          this.sourcesTypes = data
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    test(source_ids) {
      const index_source_ids = this.sources.findIndex(obj => {
        return obj.source_id == source_ids
      })
      if (index_source_ids >= 0) {
        this.sources[index_source_ids].loading = true
        this.sources[index_source_ids].last_status = 'loading'
      }
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/sources/test`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          server_id: this.$route.params.server_id,
          source_ids: source_ids
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(status => {
          for (const [key, value] of Object.entries(status)) {
            const index = this.sources.findIndex(obj => {
              return obj.source_id == key
            })
            if (index >= 0) {
              this.sources[index].last_status = value
              this.sources[index].loading = false
            }
          }
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    testSources() {
      if (!this.selected.length) {
        this.$notify({
          message: this.$t('notification.unselected'),
          type: 'danger'
        })
        return
      }
      for (let i = 0; i < this.selected.length; ++i) {
        this.test([this.selected[i]])
      }
    },
    deleteSources(source_ids) {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/sources/delete`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          server_id: this.$route.params.server_id,
          source_ids: source_ids
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          const indexSet = new Set(source_ids)
          this.sources = this.sources.filter(value => {
            return !indexSet.has(value.source_id)
          })
          this.selected = []
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    openDialogRemove() {
      if (!this.selected.length) {
        this.$notify({
          message: this.$t('notification.unselected'),
          type: 'danger'
        })
        return
      }
      const indexSet = new Set(this.selected)
      const sources = this.sources
        .filter(value => {
          return indexSet.has(value.source_id)
        })
        .map(d => {
          return d['name']
        })
      const msg = sources
        .map(d => {
          return d
        })
        .join(', ')

      this.$dialog.confirm({
        message: `${this.$t('confirm.remove', {
          msg: msg
        })}?`,
        onConfirm: () => {
          this.serversLoading = true
          this.deleteSources(this.selected)
            .then(() => {
              this.$notify({
                message: this.$t('notification.removed', {
                  msg: msg
                }),
                type: 'success'
              })
            })
            .finally(() => (this.serversLoading = false))
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.table {
  width: 100%;
}
</style>
